import React from "react";

const SearchBar = ({ search, setSearch }) => {
  return (
    <div className="g-search-bar">
      <span className="g-search-icon">🔍</span>
      <input
        type="text"
        placeholder="Поиск термина..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="g-search-input"
      />
    </div>
  );
};

export default SearchBar;